import { OnSeachEvent } from 'modules/application/list/ListApplicationController';
export const ChangeSubheaderTitleEvent = 'ChangeSubheaderTitle';
import './SubheaderMoveApplication.scss';
export class SubheaderMoveApplicationController {
    static $inject = ['$rootScope', 'ContextProcessorService', 'BLIP_DOMAIN', '$state', '$window', '$translate', '$scope'];
    constructor($rootScope, ContextProcessorService, BLIP_DOMAIN, $state, $window, $translate, $scope) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.ContextProcessorService = ContextProcessorService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.$state = $state;
        this.$window = $window;
        this.$translate = $translate;
        this.$scope = $scope;
        this.disableButton = false;
        this.title = 'navbar.subheader.moveChatbots';
        this.pathButtonBack = '/application';
        this.$scope.$watch(() => {
            return $state.current.name;
        }, (newVal, oldVal) => {
            if (newVal === 'auth.application.historic') {
                this.disableButton = true;
                this.title = 'navbar.subheader.historicMoveChatbots';
                this.pathButtonBack = '/application/move';
            }
        });
    }
    onSearchBots() {
        this.$rootScope.$emit(OnSeachEvent, this.searchText);
    }
    reloadHistoric() {
        this.$window.location.href = this.$window.location.origin + '/application/historic';
        return;
    }
    goBack() {
        this.$window.location.href = this.$window.location.origin + this.pathButtonBack;
        return;
    }
}
SubheaderMoveApplicationController.$inject = ['$rootScope', 'ContextProcessorService', 'BLIP_DOMAIN', '$state', '$window', '$translate', '$scope'];
